import * as React from 'react'
import { ColumnDef, Table, Button, Paper } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { Alert } from '@mui/material';
import { ArrowDropDown, ArrowDropUp } from 'cs-kevlar-react/lib/es/icons'
import { Fade, Popper } from '@mui/material'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alert: {
      '& .MuiAlert-action': {
        marginLeft: 'auto',
        marginRight: 0,
        padding: 0,
      },
    },
  }),
)

interface AlertErrorHeaderProps {
    errorLabel: string
    errorMessage: string
    errors: ErrorDetail[]
}

export type ErrorDetail = {errorIdentifierText: string} & {error: string} & {id: string}

export const AlertErrorHeader: React.FunctionComponent<AlertErrorHeaderProps> = ({
  errorLabel,
  errorMessage,
  errors
}) => {
  const [showingErrorDetails, setShowingErrorDetails] = React.useState(false)
  const classes = useStyles({})

  const errorColumns: ColumnDef<ErrorDetail, string>[] = [
    {
      label: errorLabel,
      sortable: true,
      sortByDefault: true,
      sortValueFunc: (row: ErrorDetail) => row.errorIdentifierText,
      filterable: false,
      dataProperty: 'errorIdentifierText' as keyof ErrorDetail,
    },
    {
      label: 'Error Message',
      sortable: true,
      sortByDefault: false,
      sortValueFunc: (row: ErrorDetail) => row.error,
      filterable: false,
      dataProperty: 'error' as keyof ErrorDetail,
    },
  ]
  
  const toggleShowErrorDetails = () => {
    setShowingErrorDetails(!showingErrorDetails)
  }

  const anchorRef = React.useRef<HTMLDivElement>(null);

  return (
     <React.Fragment>
        <Alert variant="filled" severity="error" ref={anchorRef} className={classes.alert}
          action={
            <Button variant='contained' color="secondary" onClick={toggleShowErrorDetails} sx={{backgroundColor: 'transparent', '&:hover': {backgroundColor: 'transparent'}}}>
              {showingErrorDetails ? 'Hide Details' : 'Show Details'}
              {!showingErrorDetails && <ArrowDropDown/>}
              {showingErrorDetails && <ArrowDropUp/>}
            </Button>}>
            {errorMessage}
            <Popper open={showingErrorDetails} anchorEl={anchorRef.current} placement={'bottom-end'} transition>
              {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                  <Paper>
                    <Table
                      data={errors}
                      columns={errorColumns as ColumnDef<ErrorDetail, string>[]}
                      ariaLabel="Errors"
                      useDefaultRow
                      uniqueIdentifier="ErrorsList"
                    />
                  </Paper>
                </Fade>
              )}
            </Popper>
          </Alert>
    </React.Fragment>
  )
}
